/* eslint-disable */
import * as Types from '../../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type OverridePopover_TemplatesByIdsQueryVariables = Types.Exact<{
  templateIds: Array<Types.Scalars['ID']['input']>;
}>;


export type OverridePopover_TemplatesByIdsQuery = { searchTemplates: { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } | { __typename: 'QuoteTemplateConnection', edges: Array<{ __typename: 'QuoteTemplateEdge', node: { __typename: 'QuoteTemplate', id: string, resolvedAsReadModelVersionNumber?: number | null, title: string } }> } };


export const OverridePopover_TemplatesByIdsDocument = gql`
    query OverridePopover_TemplatesByIds($templateIds: [ID!]!) {
  searchTemplates(filters: {templateIds: $templateIds}, limit: 100) {
    ... on QuoteTemplateConnection {
      edges {
        node {
          id
          resolvedAsReadModelVersionNumber
          title
        }
      }
    }
  }
}
    `;

/**
 * __useOverridePopover_TemplatesByIdsQuery__
 *
 * To run a query within a React component, call `useOverridePopover_TemplatesByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOverridePopover_TemplatesByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOverridePopover_TemplatesByIdsQuery({
 *   variables: {
 *      templateIds: // value for 'templateIds'
 *   },
 * });
 */
export function useOverridePopover_TemplatesByIdsQuery(baseOptions: Apollo.QueryHookOptions<OverridePopover_TemplatesByIdsQuery, OverridePopover_TemplatesByIdsQueryVariables> & ({ variables: OverridePopover_TemplatesByIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OverridePopover_TemplatesByIdsQuery, OverridePopover_TemplatesByIdsQueryVariables>(OverridePopover_TemplatesByIdsDocument, options);
      }
export function useOverridePopover_TemplatesByIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OverridePopover_TemplatesByIdsQuery, OverridePopover_TemplatesByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OverridePopover_TemplatesByIdsQuery, OverridePopover_TemplatesByIdsQueryVariables>(OverridePopover_TemplatesByIdsDocument, options);
        }
export function useOverridePopover_TemplatesByIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OverridePopover_TemplatesByIdsQuery, OverridePopover_TemplatesByIdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OverridePopover_TemplatesByIdsQuery, OverridePopover_TemplatesByIdsQueryVariables>(OverridePopover_TemplatesByIdsDocument, options);
        }
export type OverridePopover_TemplatesByIdsQueryHookResult = ReturnType<typeof useOverridePopover_TemplatesByIdsQuery>;
export type OverridePopover_TemplatesByIdsLazyQueryHookResult = ReturnType<typeof useOverridePopover_TemplatesByIdsLazyQuery>;
export type OverridePopover_TemplatesByIdsSuspenseQueryHookResult = ReturnType<typeof useOverridePopover_TemplatesByIdsSuspenseQuery>;
export type OverridePopover_TemplatesByIdsQueryResult = Apollo.QueryResult<OverridePopover_TemplatesByIdsQuery, OverridePopover_TemplatesByIdsQueryVariables>;